import AuthHelper from "../auth/helpers/AuthHelper";
import { FREYA_LOGGING_SOURCE, ODIN_LOGGING_SOURCE } from "../constants";

export const getAppNameHeader = () => ({ "X-App-Name": AuthHelper.isFreya() ? FREYA_LOGGING_SOURCE : ODIN_LOGGING_SOURCE });
